import React from 'react';
import { Language } from '../App';
interface FooterProps {
  language: Language;
}
const content = {
  en: {
    address: '9 East 62nd St, New York, NY 10065',
    email: 'contact@pearlannbrown.com',
    legal: 'Professional medical practice. Licensed physicians in New York State.',
    copyright: '© 2026 Dermalipo. All rights reserved.'
  },
  es: {
    address: '9 East 62nd St, New York, NY 10065',
    email: 'contact@pearlannbrown.com',
    legal: 'Práctica médica profesional. Médicos con licencia en el Estado de Nueva York.',
    copyright: '© 2026 Dermalipo. Todos los derechos reservados.'
  }
};
export function Footer({
  language
}: FooterProps) {
  const t = content[language];
  return <footer className="bg-espresso border-t border-pearl/10 py-12 px-4 sm:px-6 lg:px-8" data-id="element-78" data-mp="3qcdu54puyhtz">
      <div className="max-w-7xl mx-auto" data-id="element-79" data-mp="29yxcjbkkrila">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-80" data-mp="29xvswiphtnry">
          <div data-id="element-81" data-mp="2eyjolhoo2ssi">
            <h3 className="text-pearl text-xl font-bold mb-4" data-id="element-82" data-mp="2ez1joazlf0yu">DERMALIPO</h3>
            <p className="text-pearl/60 text-sm" data-id="element-83" data-mp="3l8qvw2zluhqx">{t.legal}</p>
          </div>

          <div data-id="element-84" data-mp="3gapbneqg0cdv">
            <h4 className="text-pearl font-semibold mb-3" data-id="element-85" data-mp="3gb8vj0znlauj">
              {language === 'en' ? 'Contact' : 'Contacto'}
            </h4>
            <div className="space-y-2 text-pearl/60 text-sm" data-id="element-86" data-mp="3v9b09eif82dd">
              <p data-id="element-87" data-mp="3q8dkf8kvvkf1">{t.address}</p>
              <p data-id="element-88" data-mp="3q725qdpwgs95">{t.email}</p>
            </div>
          </div>

          <div data-id="element-89" data-mp="82ibxqv2w6ds">
            <h4 className="text-pearl font-semibold mb-3" data-id="element-90" data-mp="81ywqhwtbw3g">
              {language === 'en' ? 'Hours' : 'Horario'}
            </h4>
            <p className="text-pearl/60 text-sm" data-id="element-91" data-mp="33noucq2vvnv">
              {language === 'en' ? 'By Appointment Only' : 'Solo con Cita Previa'}
            </p>
          </div>
        </div>

        <div className="border-t border-pearl/10 pt-8 text-center" data-id="element-92" data-mp="cvtlw0v6t39x">
          <p className="text-pearl/60 text-sm" data-id="element-93" data-mp="qub5bme27tm1">{t.copyright}</p>
        </div>
      </div>
    </footer>;
}